import React from 'react';
import { defaultLanguage } from '../utils/language';

export const AppContext = React.createContext({
    language: defaultLanguage,
    translate: undefined,
    setLanguage: undefined
});